// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

// COMPARTIDO CON LARAVEL Y APP
// V.1.0

const state = {
	numerossky: [],
    waitingPIN: null
}

const getters = {
    skyaccountGetNumerosSky: state => { return state.numerossky },
    skyaccountGetIsWaitingPin: state => { return state.waitingPIN }
}

const mutations = {
    skyaccountSetNumerosSky: (state, payload) => { state.numerossky = payload },
    skyaccountClear: (state) => { state.numerossky = []; state.waitingPIN = null },
}

const actions = {
    skyaccountTryToLinkNumber: async ({getters, commit}, payload) => {
        try {
            let api2workwith = ((!payload.id || !payload.pin))? 'skyaccount/linknewmsisdn' : 'skyaccount/activatemsisdnwithpin',
                response = await axios.post(api2workwith, payload)
            
            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) {
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: response.msg,
                    color: response.class,
                    duration: 7000
                })
            }
            return response
        } catch (e) {
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                color: 'warning',
                duration: 7000
            })
        }
    },
	skyaccountUpdate: async ({commit}) => {
        try {
            // RESPONSE
            let response = await axios.get('skyaccount/getmine', { withCredentials: false })

            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) {
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: response.msg,
                    color: response.class,
                    duration: 7000
                })
            }
            
            // RESPONSE PROCESSING
            if(response.status){
                commit('skyaccountSetNumerosSky', response.data.numerosskycel)
            }
        } catch(e) {
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                color: 'warning',
                duration: 7000
            })
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};